import {
  ASSETINSPECTION_LOADING,
  GET_ASSETINSPECTION,
  GET_ASSETINSPECTION_SUCCESS,
  GET_ASSETINSPECTION_FAIL,
  ADD_ASSETINSPECTION_SUCCESS,
  ADD_ASSETINSPECTION_FAIL,
  DELETE_ASSETINSPECTION_SUCCESS,
  DELETE_ASSETINSPECTION_FAIL,
  UPDATE_ASSETINSPECTION_SUCCESS,
  UPDATE_ASSETINSPECTION_FAIL,
  ASSETINSPECTION_RESET,
  ASSETINSPECTION_RESET_CREATE
} from "./actionType";

const INIT_STATE = {
  assetInspections: [],
  assetInspectionAdded: {},
  error: {},
};

const AssetInspection = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ASSETINSPECTION_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ASSETINSPECTION:
          return {
            ...state,
            assetInspections: action.payload.data,
            isAssetInspectionCreated: false,
            isAssetInspectionSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_ASSETINSPECTION_FAIL:
      switch (action.payload.actionType) {
        case GET_ASSETINSPECTION_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAssetInspectionCreated: false,
            isAssetInspectionSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_ASSETINSPECTION: {
      return {
        ...state,
        isAssetInspectionCreated: false,
        loading: true,
      };
    }

    case ASSETINSPECTION_LOADING: {
      return {
        ...state,
        isAssetInspectionCreated: false,
        loading: true,
      };
    }

    case ADD_ASSETINSPECTION_SUCCESS:
      return {
        ...state,
        isAssetInspectionCreated: true,
        loading: false,
        assetInspections: [action.payload.data, ...state.assetInspections],
        assetInspectionAdded: action.payload.data,
      };

    case ADD_ASSETINSPECTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ASSETINSPECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        assetInspections: state.assetInspections.filter(
          assetInspection => assetInspection.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_ASSETINSPECTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ASSETINSPECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        assetInspections: state.assetInspections.map(assetInspection =>
          assetInspection.id.toString() === action.payload.data.id.toString() ? { ...assetInspection, ...action.payload.data } : assetInspection
        ),
      };

    case UPDATE_ASSETINSPECTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ASSETINSPECTION_RESET_CREATE:
      return {
        ...state,
        isAssetInspectionCreated: false,
      };

    case ASSETINSPECTION_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default AssetInspection;